export default __webpack_public_path__ + "static/dolina-sanu_hero-8960162fa3f81901d9dd17139a291545.mp4";